import { render, staticRenderFns } from "./drugInfo.vue?vue&type=template&id=2f5ea3bd&scoped=true&"
import script from "./drugInfo.vue?vue&type=script&lang=js&"
export * from "./drugInfo.vue?vue&type=script&lang=js&"
import style0 from "./drugInfo.vue?vue&type=style&index=0&id=2f5ea3bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ea3bd",
  null
  
)

export default component.exports